var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v("Your Files\n    "),
        _c(
          "a",
          {
            staticClass: "btn btn-sm btn-primary m-l-xl",
            attrs: { type: "submit" },
            on: { click: _vm.handleGetFileInput },
          },
          [
            _c("i", { staticClass: "fa fa-plus" }),
            _vm._v(" Upload Files\n    "),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          ref: "fileInput",
          staticStyle: { display: "none" },
          attrs: { type: "file", multiple: "" },
          on: { change: this.handleAddBookingFiles },
        }),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.hasFiles
        ? _c(
            "ul",
            { staticStyle: { padding: "0" } },
            _vm._l(_vm.booking.files, function (file) {
              return _c("request-file-list-item", {
                key: file.id,
                attrs: { file: file, booking: _vm.booking },
              })
            }),
            1
          )
        : _c("no-results", [_vm._v("\n    There are currently no files.\n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }